module.exports = __webpack_public_path__ + "img/Detail-w.2b80446d.png";